import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import AppBar from '@material-ui/core/AppBar';
import Avatar from '@material-ui/core/Avatar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import { Dropdown, DropdownMenu, DropdownToggle } from 'reactstrap';
import Button from '@material-ui/core/Button';
import {
    BELOW_THE_HEADER,
    COLLAPSED_DRAWER,
    FIXED_DRAWER,
    HORIZONTAL_NAVIGATION,
    INSIDE_THE_HEADER
} from '../../constants/ActionTypes';
import SearchBox from '../SearchBox';
import MailNotification from '../MailNotification/index';
import AppNotification from '../AppNotification/index';
import CardHeader from '../dashboard/Common/CardHeader/index';
import { switchLanguage, toggleCollapsedNav } from '../../appRedux/actions/Setting';
import { logoutUser } from "../../appRedux/actions/Auth";
import IntlMessages from '../../util/IntlMessages';
import LanguageSwitcher from '../LanguageSwitcher/index';
import Menu from '../TopNav/Menu';
import CompanySelector from '../TopNav/CompanySelector';
import UserInfo from '../UserInfo';
import UserInfoPopup from '../UserInfo/UserInfoPopup.js';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { bindActionCreators } from 'redux';
import * as config from '../../env-config.json';

const ACTIVITY_KEY = 'lastActivityTime';
const TIMEOUT = config.intervalTime;

class Header extends React.Component {

    onAppNotificationSelect = () => {
        this.setState({
            appNotification: !this.state.appNotification
        })
    };
    onMailNotificationSelect = () => {
        this.setState({
            mailNotification: !this.state.mailNotification
        })
    };
    onLangSwitcherSelect = (event) => {
        this.setState({
            langSwitcher: !this.state.langSwitcher, anchorEl: event.currentTarget
        })
    };
    onSearchBoxSelect = () => {
        this.setState({
            searchBox: !this.state.searchBox
        })
    };
    onUserInfoSelect = () => {
        this.setState({
            userInfo: !this.state.userInfo
        })
    };
    handleRequestClose = () => {
        this.setState({
            langSwitcher: false,
            userInfo: false,
            mailNotification: false,
            appNotification: false,
            searchBox: false
        });
    };
    onToggleCollapsedNav = (e) => {
        const val = !this.props.navCollapsed;
        this.props.toggleCollapsedNav(val);
    };
    updateSearchText(evt) {
        this.setState({
            searchText: evt.target.value,
        });
    }

    constructor() {
        super();
        this.state = {
            anchorEl: undefined,
            searchBox: false,
            visible: false,
            timeLeft: 10,
            searchText: '',
            mailNotification: false,
            userInfo: false,
            langSwitcher: false,
            appNotification: false,
            compactNav: typeof window !== 'undefined' && window.innerWidth <= 575,
        };
        this.activityChecker = null;
        this.timeClock = null;
        this.count = 0;
        this.compactNavRaf = null;
        this.toolbarResizeObserver = null;
    }

    componentDidMount() {
        localStorage.setItem(ACTIVITY_KEY, Date.now());

        document.addEventListener('click', this.resetActivity);
        document.addEventListener('keydown', this.resetActivity);
        document.addEventListener('scroll', this.resetActivity);
        document.addEventListener('mousemove', this.resetActivity);
        document.addEventListener('wheel', this.resetActivity);

        // Listen to activity updates from other tabs
        window.addEventListener('storage', this.onStorageActivity);
        this.activityChecker = setInterval(this.checkActivity, 1000);
    }

    componentWillUnmount() {
        this.cleanUp();
    }

    resetActivity = () => {
        localStorage.setItem(ACTIVITY_KEY, Date.now());
    }

    checkActivity = () => {
        const lastActivity = parseInt(localStorage.getItem(ACTIVITY_KEY), 10);
        const currentTime = Date.now();

        if (currentTime - lastActivity > TIMEOUT) {
            this.count += 1;

            if (this.count === 1) {
                this.setState({ visible: true });
                this.timeClock = setInterval(this.countdown, 1000);
            }
        }
        // CHANGE 1: Store interval references as instance variables
        this.activityChecker = null;
        this.timeClock = null;
        this.count = 0;
        

        // CHANGE 2: Bind event handlers to maintain 'this' context 
        this.handleActivity = this.handleActivity.bind(this);
        this.check = this.check.bind(this);
        this.countdown = this.countdown.bind(this);
        this.handleOk = this.handleOk.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }

    // CHANGE 3: Create a method to handle all activity events
    handleActivity = () => {
        window.lastActivity = Date.now();
    }

    // CHANGE 4: Move interval functions as class methods
    check = () => {
        var currentTime = Date.now();
        if (currentTime - window.lastActivity > TIMEOUT) {
            this.count = this.count + 1;
            if (this.count <= 1) {
                this.setState({ visible: true });
                this.timeClock = setInterval(this.countdown, 1000);
            }
        }
    }

    countdown = () => {
        if (this.state.timeLeft == 0) {
            this.clearAllIntervals();
            this.setState({ visible: false });
            this.props.logoutUser();
        }
        if (this.state.visible == true && this.state.timeLeft > 0) {
            this.setState({ timeLeft: this.state.timeLeft - 1 });
        } else {
            clearInterval(this.timeClock);
        }
    }

    handleOk = () => {
        clearInterval(this.timeClock);
        this.setState({ visible: false, timeLeft: 10 }); // CHANGE 5: Reset to 10 instead of 20
        this.count = 0;
    }

    handleCancel = () => {
        this.clearAllIntervals();
        this.setState({ visible: false });
        this.props.logoutUser();
    }

    // CHANGE 6: Add method to clear all intervals
    clearAllIntervals = () => {
        if (this.activityChecker) {
            clearInterval(this.activityChecker);
            this.activityChecker = null;
        }
        if (this.timeClock) {
            clearInterval(this.timeClock);
            this.timeClock = null;
        }
    }

    // CHANGE 7: Add componentDidMount to setup event listeners
    componentDidMount() {
        window.lastActivity = Date.now();

        // Add event listeners
        document.addEventListener('click', this.handleActivity);
        document.addEventListener('keydown', this.handleActivity);
        document.addEventListener('scroll', this.handleActivity);
        document.addEventListener('mousemove', this.handleActivity);

        // Start activity checker
        this.activityChecker = setInterval(this.check, 2000);

        window.addEventListener('resize', this.scheduleCompactNavUpdate);
        if (typeof ResizeObserver !== 'undefined' && this.toolbarRef) {
            this.toolbarResizeObserver = new ResizeObserver(this.scheduleCompactNavUpdate);
            this.toolbarResizeObserver.observe(this.toolbarRef);
        }
        this.scheduleCompactNavUpdate();
    }

    // CHANGE 8: Add componentWillUnmount to cleanup
    componentWillUnmount() {
        // Remove event listeners
        document.removeEventListener('click', this.handleActivity);
        document.removeEventListener('keydown', this.handleActivity);
        document.removeEventListener('scroll', this.handleActivity);
        document.removeEventListener('mousemove', this.handleActivity);

        // Clear all intervals
        this.clearAllIntervals();

        window.removeEventListener('resize', this.scheduleCompactNavUpdate);
        if (this.toolbarResizeObserver) {
            this.toolbarResizeObserver.disconnect();
            this.toolbarResizeObserver = null;
        }
        if (this.compactNavRaf) {
            cancelAnimationFrame(this.compactNavRaf);
            this.compactNavRaf = null;
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            prevProps.location !== this.props.location ||
            prevProps.width !== this.props.width ||
            prevState.compactNav !== this.state.compactNav
        ) {
            this.scheduleCompactNavUpdate();
        }
    }

    scheduleCompactNavUpdate = () => {
        if (this.compactNavRaf) {
            cancelAnimationFrame(this.compactNavRaf);
        }
        this.compactNavRaf = requestAnimationFrame(() => {
            this.compactNavRaf = requestAnimationFrame(this.updateCompactNav);
        });
    };

    updateCompactNav = () => {
        const PHONE_COMPACT_MAX = 575;
        const NAV_FIT_BUFFER = 16;

        if (typeof window === 'undefined') {
            return;
        }

        if (window.innerWidth <= PHONE_COMPACT_MAX) {
            if (!this.state.compactNav) {
                this.setState({ compactNav: true });
            }
            return;
        }

        const toolbar = this.toolbarRef;
        const left = this.leftRef;
        const company = this.companyRef;
        const right = this.rightRef;
        const nav = this.navRef;
        if (!toolbar || !left || !company || !right) {
            return;
        }

        const burgerWidth = (this.state.compactNav && this.burgerRef) ? this.burgerRef.offsetWidth : 0;
        const available = toolbar.clientWidth - (left.offsetWidth - burgerWidth) - company.offsetWidth - right.offsetWidth - NAV_FIT_BUFFER;
        const navList = nav ? nav.querySelector('.navbar-nav') : null;
        const needed = navList ? navList.scrollWidth : 0;
        const compactNav = needed > available;

        if (this.state.compactNav !== compactNav) {
            this.setState({ compactNav });
        }
    };

    countdown = () => {
        const { timeLeft } = this.state;

        if (timeLeft <= 0) {
            this.setState({ visible: false });
            this.cleanUp();
            this.props.logoutUser();
        } else {
            this.setState({ timeLeft: timeLeft - 1 });
        }
    }

    onStorageActivity = (event) => {
        if (event.key === ACTIVITY_KEY) {
            this.resetActivity();
        }

        if (event.key === 'logout') {
            this.cleanUp();
            this.setState({ visible: false });
            this.props.logoutUser();
            localStorage.removeItem('logout', Date.now());
            localStorage.removeItem('lastActivityTime', Date.now());
        }

        if (event.key === 'lastActivityTime') {
            // Optional: Handle something if you want
        }

        if (event.key === 'sessionContinue') {
            clearInterval(this.timeClock);
            this.setState({ visible: false, timeLeft: 20 });
            this.count = 0;
            this.resetActivity();
            localStorage.removeItem('sessionContinue', Date.now());
        }      
    }

    handleOk = () => {
        clearInterval(this.timeClock);
        this.setState({ visible: false, timeLeft: 20 });
        this.count = 0;
        this.resetActivity();
        // Notify other tabs
        localStorage.setItem('sessionContinue', Date.now());
    }

    handleCancel = () => {
        this.cleanUp();
        this.setState({ visible: false });
        localStorage.setItem('logout', Date.now());
        this.props.logoutUser();
        localStorage.removeItem('logout', Date.now());
        localStorage.removeItem('lastActivityTime', Date.now());
    }

    cleanUp = () => {
        clearInterval(this.activityChecker);
        clearInterval(this.timeClock);

        document.removeEventListener('click', this.resetActivity);
        document.removeEventListener('keydown', this.resetActivity);
        document.removeEventListener('scroll', this.resetActivity);
        document.removeEventListener('mousemove', this.resetActivity);
        document.removeEventListener('wheel', this.resetActivity);

        window.removeEventListener('storage', this.onStorageActivity);

        this.count = 0;
    }

    render() {

        // let self = this;
        let user = JSON.parse(localStorage.getItem('userData'));
        let companyId = user.companyId;
        let role = user.role;
        let show = user.showMenu || false;

        const { drawerType, locale, navigationStyle, horizontalNavPosition } = this.props;
        const drawerStyle = drawerType.includes(FIXED_DRAWER) ? 'd-block d-xl-none' : drawerType.includes(COLLAPSED_DRAWER) ? 'd-block' : 'd-none';
        // window.lastActivity = Date.now();
        // let count = 0;

        // document.addEventListener('click', function () {
        //     window.lastActivity = Date.now();
        // })
        // document.addEventListener('keydown', function () {
        //     window.lastActivity = Date.now();
        // })
        // document.addEventListener('scroll', function () {
        //     window.lastActivity = Date.now();
        // })
        // document.addEventListener('mousemove', function () {
        //     window.lastActivity = Date.now();
        // })


        // var activityChecker = setInterval(check, 2000);
        // var timeClock;

        // function check() {
        //     var currentTime = Date.now();
        //     if (currentTime - window.lastActivity > TIMEOUT) {
        //         count = count + 1;
        //         if (count <= 1) {
        //             self.setState({ visible: true })
        //             timeClock = setInterval(countdown, 1000);
        //         }
        //     }
        // }

        // function countdown() {
        //     if (self.state.timeLeft == 0) {
        //         self.setState({ visible: false })
        //         clearInterval(activityChecker);
        //         clearInterval(timeClock);
        //         self.props.logoutUser()
        //     }
        //     if (self.state.visible == true && self.state.timeLeft > 0) {
        //         self.setState({ timeLeft: self.state.timeLeft - 1 })
        //     } else {
        //         clearInterval(timeClock);
        //     }
        // }
        // function handleOk() {
        //     clearInterval(timeClock);
        //     self.setState({ visible: false, timeLeft: 20 })
        //     count = 0;

        // }
        // function handleCancel() {
        //     clearInterval(activityChecker);
        //     clearInterval(timeClock);
        //     self.setState({ visible: false })
        //     self.props.logoutUser()
        // }

        
        return (
            <div>
                <Dialog
                    fullWidth={true}
                    open={this.state.visible}
                    onClose={this.handleCancel}
                >
                    <DialogTitle>Sesssion Expired Due to No Activity</DialogTitle>
                    <DialogContent>
                        <div>
                            <h2>Your Session will logout in {this.state.timeLeft} seconds.</h2>
                            <h3>Do You Want to Continue?</h3>
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleOk} color="primary">
                            Continue
                        </Button>
                        <Button onClick={this.handleCancel} color="primary" autoFocus>
                            Logout
                        </Button>
                    </DialogActions>
                </Dialog>
                <AppBar
                    className={`app-main-header ${(navigationStyle === HORIZONTAL_NAVIGATION && horizontalNavPosition === BELOW_THE_HEADER) ? 'app-main-header-top' : ''}`}>
                    <Toolbar className="app-toolbar" disableGutters={false}>
                        <div className="app-toolbar-inner" ref={(el) => { this.toolbarRef = el; }}>
                        <div className="header-left" ref={(el) => { this.leftRef = el; }}>
                        {navigationStyle === HORIZONTAL_NAVIGATION ?
                            (this.state.compactNav ?
                            <div className="header-hamburger pointer" ref={(el) => { this.burgerRef = el; }} onClick={this.onToggleCollapsedNav}>
                                <span className="jr-menu-icon">
                                    <span className="menu-icon" />
                                </span>
                            </div>
                            : null)
                            :
                            <IconButton className={`jr-menu-icon mr-3 ${drawerStyle}`} aria-label="Menu"
                                onClick={this.onToggleCollapsedNav}>
                                <span className="menu-icon" />
                            </IconButton>
                        }

                        <Link to={show == false ? `/home` : `/dashboard`}>
                            <div className="app-logos mr-2 d-none d-sm-block" >
                                <img style={{ 'maxWidth': 130 }} src="/vendors/Logo1.png" alt="Compliance" title="Compliance" />
                            </div>
                        </Link>
                        </div>

                        <div className="header-company" ref={(el) => { this.companyRef = el; }}>
                            <CompanySelector />
                        </div>

                        <div className={`header-nav${this.state.compactNav ? ' is-compact' : ''}`} ref={(el) => { this.navRef = el; }}>
                            {(navigationStyle === HORIZONTAL_NAVIGATION &&
                                horizontalNavPosition === INSIDE_THE_HEADER) &&
                                <Menu />
                            }
                        </div>

                        <ul className="header-notifications header-right list-inline" ref={(el) => { this.rightRef = el; }}>
                            {/*
                       <li className="d-inline-block d-lg-none list-inline-item">
                            <Dropdown
                                className="quick-menu nav-searchbox"
                                isOpen={this.state.searchBox}
                                toggle={this.onSearchBoxSelect.bind(this)}>

                                <DropdownToggle
                                    className="d-inline-block"
                                    tag="span"
                                    data-toggle="dropdown">
                                    <IconButton className="icon-btn size-30">
                                        <i className="zmdi zmdi-search zmdi-hc-fw"/>
                                    </IconButton>
                                </DropdownToggle>

                                <DropdownMenu right className="p-0">
                                    <SearchBox styleName="search-dropdown" placeholder=""
                                               onChange={this.updateSearchText.bind(this)}
                                               value={this.state.searchText}/>
                                </DropdownMenu>
                            </Dropdown>
                        </li>

                        <li className="list-inline-item">
                            <Dropdown
                                className="quick-menu"
                                isOpen={this.state.langSwitcher}
                                toggle={this.onLangSwitcherSelect.bind(this)}>

                                <DropdownToggle
                                    className="d-inline-block"
                                    tag="span"
                                    data-toggle="dropdown">
                                    <div className="d-flex align-items-center pointer pt-1">
                                        <i className={`flag flag-24 flag-${locale.icon}`}/>
                                    </div>
                                </DropdownToggle>

                                <DropdownMenu right className="w-50">
                                    <LanguageSwitcher switchLanguage={this.props.switchLanguage}
                                                      handleRequestClose={this.handleRequestClose}/>
                                </DropdownMenu>
                            </Dropdown>
                            </li>

   <li className="list-inline-item mail-tour">
                            <Dropdown
                                className="quick-menu"
                                isOpen={this.state.mailNotification}
                                toggle={this.onMailNotificationSelect.bind(this)}
                              >
                               <DropdownToggle
                                    className="d-inline-block"
                                    tag="span"
                                    data-toggle="dropdown">

                                    <IconButton className="icon-btn size-20 font-size-20">
                                        <i className="zmdi zmdi-comment-alt-text icon-alert zmdi-hc-fw"/>
                                    </IconButton>
                                </DropdownToggle>

                                <DropdownMenu right>
                                    <CardHeader styleName="align-items-center"
                                                heading={<IntlMessages id="mailNotification.title"/>}/>
                                    <MailNotification/>
                                </DropdownMenu>
                            </Dropdown>
                        </li>
                       */}
                            {/*<li className="list-inline-item">
                         <SearchBox styleName="d-none d-lg-block" placeholder=""
                             onChange={this.updateSearchText.bind(this)}
                             value={this.state.searchText}
                           />
                       </li>*/}


                            <li className="list-inline-item app-tour">
                                <Dropdown
                                    className="quick-menu"
                                    isOpen={this.state.appNotification}
                                    toggle={this.onAppNotificationSelect.bind(this)}>

                                    <DropdownToggle
                                        className="d-inline-block"
                                        tag="span"
                                        data-toggle="dropdown">
                                        <IconButton className="icon-btn size-20 font-size-20">
                                            <i className="zmdi zmdi-notifications-active icon-alert animated infinite wobble" />
                                        </IconButton>
                                    </DropdownToggle>

                                    <DropdownMenu right>
                                        <CardHeader styleName="align-items-center"
                                            heading={<IntlMessages id="appNotification.title" />} />
                                        <AppNotification />
                                    </DropdownMenu>
                                </Dropdown>
                            </li>


                            {navigationStyle === HORIZONTAL_NAVIGATION &&
                                <li className="list-inline-item user-nav">
                                    <UserInfo />
                                </li>}
                        </ul>
                        </div>
                    </Toolbar>
                </AppBar>
            </div>
        );
    }

}

const mapStateToProps = ({ settings, companyReducer }) => {
    const { drawerType, locale, navigationStyle, horizontalNavPosition, navCollapsed, width } = settings;
    // Subscribe so Header re-reads localStorage after CompanySelector clears/selects a company
    const showMenu = companyReducer && companyReducer.ShowMenu;
    return { drawerType, locale, navigationStyle, horizontalNavPosition, navCollapsed, width, showMenu }
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        logoutUser,
        toggleCollapsedNav,
        switchLanguage
    }, dispatch)
}


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header));
